import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _omit from "lodash/omit";
import _get from "lodash/get";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import { addTempData, removeTempData, getSecurityQuestions, createTUCustomer, authenticateWithGoogle, authenticateWithApple } from "../actions";
import { AuthProviders, ThirdPartyAuthFailReasons } from "../constants/internal";

var getlastThirdPartyAuthFailReason = function getlastThirdPartyAuthFailReason(payload) {
  if (_get(payload, 'data.error.data.requires_password')) return ThirdPartyAuthFailReasons.REQUIRES_PASSWORD;
  return ThirdPartyAuthFailReasons.OTHER;
};

var clearThirdPartyAuthFailState = function clearThirdPartyAuthFailState(state) {
  return _omit(state, ['lastThirdPartyAuthFailProvider', 'lastThirdPartyAuthFailReason', 'code', 'email']);
};

var reducer = createReducer((_createReducer = {}, _defineProperty(_createReducer, addTempData, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), payload);
}), _defineProperty(_createReducer, removeTempData, function (state, key) {
  return _omit(state, key);
}), _defineProperty(_createReducer, getSecurityQuestions.success, function (state, questions) {
  return _objectSpread(_objectSpread({}, state), {}, {
    securityQuestions: questions
  });
}), _defineProperty(_createReducer, createTUCustomer.fail, function (state, payload) {
  var internal_message = payload.internal_message,
      _payload$blocking_ema = payload.blocking_emails,
      blocking_emails = _payload$blocking_ema === void 0 ? [] : _payload$blocking_ema;
  var hasDuplicateEmail = blocking_emails.length > 0 && internal_message === 'Active TU Enrollment already exists for SSN';
  return _objectSpread(_objectSpread({}, state), {}, {
    duplicateEmail: hasDuplicateEmail && _get(blocking_emails, '[0]')
  });
}), _defineProperty(_createReducer, authenticateWithGoogle.SUCCESS_TYPE, clearThirdPartyAuthFailState), _defineProperty(_createReducer, authenticateWithApple.SUCCESS_TYPE, clearThirdPartyAuthFailState), _defineProperty(_createReducer, authenticateWithGoogle.FAIL_TYPE, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    lastThirdPartyAuthFailProvider: AuthProviders.GOOGLE,
    lastThirdPartyAuthFailReason: getlastThirdPartyAuthFailReason(payload)
  });
}), _defineProperty(_createReducer, authenticateWithApple.FAIL_TYPE, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    lastThirdPartyAuthFailProvider: AuthProviders.APPLE,
    lastThirdPartyAuthFailReason: getlastThirdPartyAuthFailReason(payload),
    code: _get(payload, 'temp.code'),
    email: _get(payload, 'temp.email')
  });
}), _createReducer), {});
export default reducer;